import React from "react";
import "./Work.css";
function Work() {
  const openInternshipCertificate = () => {
    window.open(
      "https://drive.google.com/file/d/1rAwFlTLPalXmQ11ZIBCWS91h2v-RTKZl/view?usp=sharing",
      "_blank"
    );
  };
  return (
    <div className="container mb-5">
      <h1
        className="text-center p-5 fw-light "
        style={{
          color: "navy",
        }}
      >
        {" "}
        Work Experience
      </h1>
      <div className="row text-center d-flex justify-content-center">
        <div className="col-md-6">
          <div className="card mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                Full Stack Developer role at RayMedis Medical Technologies{" "}
                <span className="text-muted"> (05/2022 - 09/2022)</span>
              </h5>
              <p className="card-text">
                I had been working on the development of PACS Administration
                System for medical industry. I have learnt some important
                protocols which are relevant and widely used in the development
                of medical device software. We have been using dicom 3.0 for the
                development
              </p>
              <button
                class="btn btn-primary"
                onClick={openInternshipCertificate}
              >
                Certificate
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card mx-2 my-2">
            <div className="card-body">
              <h5 className="card-title">
                Software Engineer @
                <a
                  href="https://www.covalenseglobal.com/"
                  className="text-decoration-none"
                >
                  {" "}
                  Covalense Global
                </a>
                <span className="text-muted"> (10/2023 - present)</span>
              </h5>
              <p className="card-text">
                Technologies that i have worked include Angular 19, Java
                SpringBoot. I have worked as support on multiple client project.
              </p>
              <button class="btn btn-primary" disabled>
                Certificate
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Work;
